import React, { useState, useEffect, useRef } from "react";
import { Row, Card, Button, Form } from "react-bootstrap";
import styles from "./signup.module.css";
import PinInput from "react-pin-input";
import worker_script from "./Worker_script.js";
import CommonButton from "../CommonButton/CommonButton.js";

const EmailVerification = ({
  username,
  setStepToShow,
  setOtp,
  otp,
  otperror,
  loading,
  otpVerification,
  resendOtpVerification,
  navigate,
  errorMessage,
  Title,
  isEdit,
}) => {
  const mediaMatch = window.matchMedia(
    "(min-width:300px) and (max-width: 400px)"
  );
  const inputStyle = {
    spinInput: {
      textAlign: "center",
      width: "42px",
      height: "44px",
      background: "#FFFFFF",
      borderRadius: "6px",
      marginLeft: mediaMatch.matches ? "3px" : "13px",
      fontFamily: "geomanistregular",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "20px",
      color: "#3C404A",
    },
  };

  const [time, setTime] = useState(180);
  const workerRef = useRef();
  const myRef = useRef(null)

  useEffect(() => {
    workerRef.current = new Worker(worker_script);

    workerRef.current.onmessage = (event) => {
      const { time } = event.data;
      setTime(time);

      if (time === 0) {
        workerRef.current.postMessage({ turn: "off" });
      }
    };
    workerRef.current.postMessage({ turn: "on" });

    return () => {
      workerRef.current.terminate();
    };
  }, []);

  const handleResend = () => {
    resendOtpVerification();
    myRef.current.clear();
    setTime(180);
    workerRef.current.postMessage({ turn: "on" });
  };

  const otpVerified = () => {
    navigate("/purpose");
  };

  return (
    <>
      <Row className={styles.title}>{Title}</Row>
      <Row className={styles.subTitle}>
        Enter the 6-digit OTP sent to your email address
      </Row>

      {isEdit === true && (
        <Row className={styles.emailStyle}>
          {username ? username : ""}
          <span
            className={styles.goBackText}
            onClick={() => setStepToShow("login")}
            style={{ paddingLeft: "4px" }}
          >
            Edit
          </span>
        </Row>
      )}
      <Row className={styles.otpInput}>
        <PinInput
        ref={myRef}
          length={6}
          initialValue=""
          type="numeric"
          inputMode="number"
          onComplete={(value, index) => {
            setOtp(value);
          }}
          clearValue={() => setOtp("")}
          inputStyle={{ ...inputStyle.spinInput }}
          inputFocusStyle={{ border: "1px solid #3C404A" }}
          autoSelect={true}
          regexCriteria={/[0-9]/}
        />
      </Row>
      <div className={styles.errorState}>{otperror}</div>

      <div className={styles.expiresdiv}>
        {time > 0 ? (
          <span className={styles.expiresdivspan}>Expires in {time}s</span>
        ) : (
          <span
            className={styles.resendotpspan}
            onClick={handleResend}
            style={{ cursor: "pointer" }}
          >
            Resend OTP
          </span>
        )}
      </div>

      <Row className="m-0 mt-4">
        <div className={styles.errorState}>{errorMessage}</div>
        <CommonButton
          title="Verify OTP"
          onClick={otpVerification}
          loading={loading}
          disabled={loading}
        />
      </Row>
    </>
  );
};

export default EmailVerification;
